<template>
  <div>
    <el-dialog title="目标院校"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :append-to-body="true"
               width="554rem"
               :before-close="handleClose">

      <el-form :model="form"
               :rules="rules"
               ref="formRef"
               label-width="130rem">
        <el-form-item label="目标院校"
                      prop="college_name">
          <el-input placeholder="请输入你的目标院校"
                    v-model="form.college_name" />
        </el-form-item>
        <el-form-item label="目标专业"
                      prop="professional">
          <el-input placeholder="请输入你的目标专业"
                    v-model="form.professional" />
        </el-form-item>

      </el-form>
      <div class="btn_warp">
        <div @click="handleClose">
          取消
        </div>
        <div @click="save">
          确定
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadFile, uploadImageAuto } from '@/api/upload.js'
import { getUserInfo, getSubmitGoalCollege } from '@/api/subject.js'

export default {
  data () {
    return {
      dialogVisible: false,
      form: {},
      images: [],
      form: { college_name: '', professional: '' },
      rules: {
        professional: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        college_name: [
          { required: true, message: '请输入', trigger: 'blur' },
        ]
      }
    }

  },


  methods: {

    handleClose () {
      this.dialogVisible = false
      this.images = []
    },
    async save () {
      this.$refs.formRef.validate(async val => {
        if (!val) return
        const data = {
          ...this.form
        }
        const { status } = await getSubmitGoalCollege(data)
        if (status === 200) {
          this.$message.success('设置成功')
          this.form = {
            college_name: '',
            professional: '',
          }
        }
        this.dialogVisible = false
        this.$parent.getInfo()
      })
    },

  }
}
</script>

<style lang="scss" scoped>
.btn_warp {
  height: 64rem;
  border-top: 1rem solid #e5e5e5;
  display: flex;
  width: 554rem;
  margin-left: -32rem;
  margin-top: 16rem;
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &:nth-child(1) {
      font-size: 24rem;
      font-weight: 400;
      color: #333;
      border-right: 1rem solid #e5e5e5;
    }
    &:nth-child(2) {
      font-size: 24rem;
      font-weight: 400;
      color: #2196f3;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 12rem 32rem 0rem 32rem;
}

::v-deep .el-dialog__header {
  font-size: 18rem;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
::v-deep .el-dialog {
  border-radius: 10rem;
  margin-top: 23vh !important;
}

::v-deep .el-form-item__label {
  color: #333333;
  font-size: 24rem;
  font-weight: 400;
}
.add_img {
  width: 120rem;
  height: 120rem;
  background: #f6f6f6;
  border-radius: 10rem;
  font-size: 20rem;
  font-weight: 500;
  color: #666666;
  text-align: center;
  cursor: pointer;
  img {
    width: 40rem;
    height: 34rem;
    margin-top: 26rem;
    margin-bottom: 6rem;
  }
}
.img_list {
  // margin-top: 30rem;
  display: flex;
  .img_wrap {
    position: relative;
    margin-right: 24rem;
    display: flex;
    width: 120rem;
    height: 120rem;
    .del {
      position: absolute;
      right: -15rem;
      top: -15rem;
      width: 30rem;
      height: 30rem;
      cursor: pointer;
    }
    .answer {
      border-radius: 10rem;
      width: 120rem;
      height: 120rem;
    }
  }
}
.block {
  display: flex;
  margin-bottom: 20rem;
  span {
    padding: 7rem 18rem;
    font-size: 20rem;
    // font-weight: bold;
    color: #666666;
    border-radius: 5rem;
    background: #f6f6f6;
    &:nth-child(2) {
      margin-left: 20rem;
    }
    &:nth-child(3) {
      margin-left: 20rem;
    }
  }
}
.isActive {
  background: #007af0 !important;
  color: white !important;
}

::v-deep .el-dialog__close {
  display: none;
}
::v-deep .el-dialog__title {
  color: var(--light-333333, #333);
  text-align: center;

  font-size: 24rem;
  font-style: normal;
  font-weight: 600;
  line-height: 36px; /* 150% */
}
.el-form-item {
  margin-bottom: 24rem !important;
}
::v-deep .el-textarea__inner {
  font-size: 24rem;
}
::v-deep .el-dialog {
  border-radius: 32rem;
}
.desction {
  font-size: 16rem;
  // font-weight: bold;
  color: #ff6147;
}
</style>